import request from './request.js';
import {requestbody} from './request.js'

// 查询当前用户下所有的公司信息
export async function queryCompanyList(params = {}) {
    return await request('/sys/queryCompanyList', 'post', params)
}

//查询业务类型
export async function ywlxquery(params = {}) {
    return await requestbody('business/queryType', 'post', params);
}

// 代扣代缴 分页查询
export async function dkdj_query(params = {}) {
    return await requestbody('/iinvWithheld/page', 'post', params)
}

// 设置处理状态
export async function setBusinessMatchStatus(params = {}) {
    return await requestbody('/iinvWithheld/setBusinessMatchStatus', 'post', params)
}
